

import { useEffect, useState } from "react";

const useWebSocket = (url) => {
  const [kioskMaintenanceStatus, setKioskMaintenanceStatus] = useState(() => {
    const savedData = localStorage.getItem("kioskMaintenance");
    return savedData ? JSON.parse(savedData) : {};
  });

  const [isGlobalMaintenance, setIsGlobalMaintenance] = useState(() => {
    return localStorage.getItem("isGlobalMaintenance") === "true";
  });

  useEffect(() => {
    const socket = new WebSocket(url);

    socket.onmessage = (event) => {
      //console.log("🔹 WebSocket Message Received:", event.data); // LOG THE RAW MESSAGE
      
      try {
        const data = JSON.parse(event.data); // Parse JSON message
        //console.log("✅ Parsed WebSocket Data:", data); // LOG PARSED DATA
        if (data.IsGlobal) {
          //console.log("🌍 Global Maintenance Mode:", data.IsMaintenanceMode);
          // Handle global maintenance mode
          setIsGlobalMaintenance(data.IsMaintenanceMode);
          localStorage.setItem("isGlobalMaintenance", JSON.stringify(data.IsMaintenanceMode));

          // If global maintenance mode is ON, mark all kiosks as under maintenance
          if (data.IsMaintenanceMode) {
            setKioskMaintenanceStatus((prev) => {
              const updatedState = Object.keys(prev).reduce((acc, kiosk) => {
                acc[kiosk] = true;
                return acc;
              }, {});
              localStorage.setItem("kioskMaintenance", JSON.stringify(updatedState));
              return updatedState;
            });
          }
        } else if (data.Kiosk && typeof data.IsMaintenanceMode === "boolean") {
          console.log(`🛠️ Updating Maintenance Mode for Kiosk: ${data.Kiosk} -> ${data.IsMaintenanceMode}`);
          // Handle individual kiosk update
          setKioskMaintenanceStatus((prev) => {
            const updatedState = { ...prev, [data.Kiosk]: data.IsMaintenanceMode };
            localStorage.setItem("kioskMaintenance", JSON.stringify(updatedState));
            return updatedState;
          });
        }
      } catch (error) {
        console.error("Invalid WebSocket message format:", event.data);
      }
    };

    return () => {
      socket.close();
    };
  }, [url]);

  return { kioskMaintenanceStatus, isGlobalMaintenance };
};

export default useWebSocket;

